import { render, staticRenderFns } from "./EditorOverlay.vue?vue&type=template&id=134d8cd0&scoped=true&"
import script from "./EditorOverlay.vue?vue&type=script&lang=js&"
export * from "./EditorOverlay.vue?vue&type=script&lang=js&"
import style0 from "./EditorOverlay.vue?vue&type=style&index=0&id=134d8cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d8cd0",
  null
  
)

export default component.exports